module.exports = __webpack_public_path__ + "static/media/IMG_20180203_103206.1aa35984.jpg";